import React, { useState } from 'react';
import { SendIcon } from 'lucide-react';
interface ChatInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
}
export function ChatInput({
  onSend,
  disabled
}: ChatInputProps) {
  const [input, setInput] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input.trim() && !disabled) {
      onSend(input.trim());
      setInput('');
    }
  };
  return <form onSubmit={handleSubmit} className="border-t border-gray-200 p-4" data-id="element-25">
      <div className="flex gap-2" data-id="element-26">
        <input type="text" value={input} onChange={e => setInput(e.target.value)} placeholder="Type your message..." disabled={disabled} className="flex-1 px-4 py-3 border border-gray-300 rounded-full focus:outline-none focus:border-purple-600 disabled:bg-gray-100 disabled:cursor-not-allowed" data-id="element-27" />
        <button type="submit" disabled={!input.trim() || disabled} className="px-6 py-3 bg-purple-600 text-white rounded-full hover:bg-purple-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors flex items-center gap-2" data-id="element-28">
          <SendIcon className="w-4 h-4" data-id="element-29" />
        </button>
      </div>
    </form>;
}